import type { JSX } from 'react';

import { Translate } from '@change-corgi/core/react/i18n';
import { TabLink, TabLinks } from '@change-corgi/design-system-legacy/components/navigation';

import { EditForm } from './components/EditForm';
import { Settings } from './components/Settings';
import { usePageBody } from './hooks/usePageBody';

export function PageBody(): JSX.Element {
	const {
		data: { selectedTab },
	} = usePageBody();

	return (
		<div className="container sm:pt-12 md:pt-14">
			<TabLinks
				selected={selectedTab}
				data-qa="page-body-tab-links"
				sx={{
					nav: {
						// eslint-disable-next-line @typescript-eslint/naming-convention
						'& > div:first-of-type': {
							borderBottom: '2px solid var(--stroke-weaker-color)',
						},
						// eslint-disable-next-line @typescript-eslint/naming-convention
						'ul > li > a > span': {
							fontFamily: 'unset',
						},
						...(selectedTab === 'edit' && {
							// eslint-disable-next-line @typescript-eslint/naming-convention
							'ul > li:first-of-type': {
								color: 'var(--typography-interactive-color)',
								fontWeight: 700,
								borderBottom: '2px solid var(--stroke-selected-color)',
							},
							// eslint-disable-next-line @typescript-eslint/naming-convention
							'ul > li:last-of-type': {
								color: 'var(--typography-weaker-color)',
							},
						}),
						...(selectedTab === 'settings' && {
							// eslint-disable-next-line @typescript-eslint/naming-convention
							'ul > li:first-of-type': {
								color: 'var(--typography-weaker-color)',
							},
							// eslint-disable-next-line @typescript-eslint/naming-convention
							'ul > li:last-of-type': {
								color: 'var(--typography-interactive-color)',
								fontWeight: 700,
								borderBottom: '2px solid var(--stroke-selected-color)',
							},
						}),
					},
				}}
			>
				<TabLink data-qa="edit-tab" name="edit" to="#">
					<Translate value="corgi.petition.edit.tabs.edit_v2" />
				</TabLink>
				<TabLink data-qa="settings-tab" name="settings" to="?tab=settings">
					<Translate value="corgi.petition.edit.tabs.settings" />
				</TabLink>
			</TabLinks>
			{selectedTab === 'edit' && (
				<div className="sm:pt-8 md:pt-10">
					<EditForm />
				</div>
			)}
			{selectedTab === 'settings' && (
				<div className="sm:pt-8 md:pt-8">
					<Settings />
				</div>
			)}
		</div>
	);
}
